import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IVideosContext, VideosContext } from '../../videosState/videosContext';
import List from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Videos.module.scss';

const Videos: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, videos, currentPage, countOfItems } = useContext<IVideosContext>(VideosContext);

	return (
		<>
			{videos.videosCount ? (
				<div className={style.container} data-test="Videos">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={videos.videosCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default Videos;
